const API_ORIGIN = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");

/** A stored media path ("/uploads/...") or URL, as something an <img> can load. */
export const mediaUrl = (pathOrUrl) => {
    if (!pathOrUrl) return "";
    if (/^(https?:|blob:|data:)/.test(pathOrUrl)) return pathOrUrl;
    return `${API_ORIGIN}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;
};

export const fileName = (pathOrUrl) => decodeURIComponent((pathOrUrl || "").split("/").pop() || "");
